import { APP_INITIALIZER, NgModule } from "@angular/core";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { AngularFireModule, FIREBASE_OPTIONS } from "@angular/fire";
import { AngularFireAuthModule } from "@angular/fire/auth";

import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { ToastrModule } from "ngx-toastr";
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from "@angular/common/http";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { StoreModule } from "@ngrx/store";
import { DragulaService } from "ng2-dragula";
import { NgxSpinnerModule } from 'ngx-spinner';
import {NgcCookieConsentModule, NgcCookieConsentConfig} from 'ngx-cookieconsent';

import {
  PerfectScrollbarModule,
  PERFECT_SCROLLBAR_CONFIG,
  PerfectScrollbarConfigInterface
} from 'ngx-perfect-scrollbar';

import { AppRoutingModule } from "./app-routing.module";
import { SharedModule } from "./shared/shared.module";
import { AppComponent } from "./app.component";
import { ContentLayoutComponent } from "./layouts/content/content-layout.component";
import { FullLayoutComponent } from "./layouts/full/full-layout.component";

import { AuthService } from "./shared/auth/auth.service";
import { AuthorizeGuard } from "./shared/auth/auth-guard.service";
import { WINDOW_PROVIDERS } from './shared/services/window.service';
import { ApiModule } from "./api-client/api.module";
import { LoadingService } from "./shared/services/loading.service";
import { HttpAuthInterceptor } from "./shared/services/http-auth-interceptor.service";
import { AppInitService } from "./shared/services/app-init.service";
import { environment } from "environments/environment";
import { BASE_PATH } from "./api-client";
import { UtilityService } from "@shared/services/utility.service";
import { AuthorizeAdminGuard } from "@shared/auth/auth-guard-admin.service";

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
  wheelPropagation: false
};

const cookieConfig:NgcCookieConsentConfig = {
  "cookie": {
    "domain": "keye.key2.it"
  },
  "position": "bottom",
  "theme": "block",
  "palette": {
    "popup": {
      "background": "#1f1229",
      "text": "#ffffff",
      "link": "#ffffff"
    },
    "button": {
      "background": "#7030a0",
      "text": "#ffffff",
      "border": "transparent"
    }
  },
  "type": "info",
  "content": {
    "href": "https://keye.key2.it/assets/info/cookiepolicy.pdf",
  }
}


export function init_app(appLoadService: AppInitService) {
  return () => appLoadService.init();
}
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

@NgModule({
  declarations: [AppComponent, FullLayoutComponent, ContentLayoutComponent],
  imports: [
    ApiModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    SharedModule,
    HttpClientModule,
    //AngularFireModule.initializeApp(firebaseConfig),
    AngularFireAuthModule,
    ToastrModule.forRoot(),
    NgbModule,
    NgxSpinnerModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
    NgcCookieConsentModule.forRoot(cookieConfig),
    PerfectScrollbarModule
  ],
  providers: [
     AppInitService,
    {
      provide: APP_INITIALIZER,
      useFactory: init_app,
      deps: [AppInitService],
      multi: true
    },
    {   
      provide: BASE_PATH,
      useFactory: () => {
                    return environment.apiConfig.basePath
             }
      },
    {
    provide:HTTP_INTERCEPTORS,
    useClass:HttpAuthInterceptor,
    multi:true
    },
    AuthService,
    AuthorizeGuard,
    AuthorizeAdminGuard,
    LoadingService,
    UtilityService,
    DragulaService,
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    },
    { provide: PERFECT_SCROLLBAR_CONFIG, useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG },
    WINDOW_PROVIDERS
  ],
  bootstrap: [AppComponent] 
})
export class AppModule {}  
